import OptionsOverview from 'Components/Organisms/OptionList/OptionsOverview/OptionsOverview';
import PageTemplate from 'Components/Templates/Page/Page/PageTemplate';
import React from 'react';
import { Helmet } from 'react-helmet-async';

const OptionsPage = () => {
    return <PageTemplate>
        <Helmet>
            <title>Opties - Growing People B.V.</title>
        </Helmet>

        <OptionsOverview />
    </PageTemplate>;
}

export default OptionsPage;